export { LogoBox, type LogoBoxProps } from './LogoBox';
export { logoBoxVariants, type LogoBoxVariantProps } from './logo-box.variants';
